<footer>
  <div class="footer-container">
    <div class="footer-section">
      <a translate [routerLink]="['/privacy-policy']" aria-label="Privacy Policy">privacy_policy.title</a>
    </div>
  </div>
</footer>